import { useRef } from "react";

const defaultObject = {};

export function useLazyRef<T>(init: () => T): React.MutableRefObject<T> {
    const ref = useRef<T | typeof defaultObject>(defaultObject);

    if (ref.current === defaultObject) {
        ref.current = init();
    }

    return ref as React.MutableRefObject<T>;
}
